import { render, staticRenderFns } from "./LeaderboardTeamComponent.vue?vue&type=template&id=18b68176&scoped=true&"
import script from "./LeaderboardTeamComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardTeamComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardTeamComponent.vue?vue&type=style&index=0&id=18b68176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b68176",
  null
  
)

export default component.exports